export interface LockoutSubscriptionState {
  subscribed: boolean;
  status: string | null;
  gracePeriodEnd: string | null;
}

export type LockoutReason = "cancelled" | null;

export interface LockoutDecision {
  shouldRedirect: boolean;
  reason: LockoutReason;
}

const PASS: LockoutDecision = { shouldRedirect: false, reason: null };
const REDIRECT_CANCELLED: LockoutDecision = {
  shouldRedirect: true,
  reason: "cancelled",
};

export function computeLockoutDecision(
  state: LockoutSubscriptionState,
  now: Date = new Date()
): LockoutDecision {
  if (state.status === "cancelled") return REDIRECT_CANCELLED;

  if (state.status === "past_due") {
    if (!state.gracePeriodEnd) return REDIRECT_CANCELLED;
    const graceEnd = new Date(state.gracePeriodEnd);
    if (Number.isNaN(graceEnd.getTime()) || graceEnd <= now) {
      return REDIRECT_CANCELLED;
    }
    return PASS;
  }

  if (state.status === "active" && state.subscribed) return PASS;

  return REDIRECT_CANCELLED;
}
